import React from 'react';
import ReactTooltip from 'react-tooltip'
import Form from '../../../components/common/Form';
import $ from 'jquery';
import InfoCircle from '../../common/InfoCircle';

class FacebookMultiplePostPreview extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                email: "",
                password: ""
            },
            errors: {},
            broadCastNumOfSubscribers: props.broadCastNumOfSubscribers || 0
        };
    }

    //calculateMultipost = () => {
    //    //console.log("calculateMultipost ");
    //    let posts = $('#multiple-posts .preview-post').length;
    //    console.log("posts ", posts);
    //    let multipleWidth = posts * 256;
    //    $('.multiple-posts').css('width', multipleWidth + 'px')
    //};

    scrollFun = (e) => {
        let side_to_go = e.target.id;
        let multipleSlider = $("#multiple-posts .preview-screen"), y;
        //console.log('go-multipleSlider', multipleSlider.width());
        //console.log('go-multipleSlider.scrollLeft()', multipleSlider.scrollLeft());
        if (side_to_go === "posts-arrow-right") {
            //console.log('go-right555555');
            y = ((multipleSlider.width() / 2) + 110) + multipleSlider.scrollLeft();
            multipleSlider.animate({
                scrollLeft: y
            })
        } else {
            y = ((multipleSlider.width() / 2) + 110) - multipleSlider.scrollLeft();
            multipleSlider.animate({
                scrollLeft: -y
            })
        }
        //console.log('go-y', y);
    };

    componentDidUpdate=()=> {
        //console.log('go-right555555');
        //this.calculateMultipost();
        if (this.state.broadCastNumOfSubscribers.toString() !== this.props.broadCastNumOfSubscribers.toString()) {
            this.setState({broadCastNumOfSubscribers: this.props.broadCastNumOfSubscribers});
        }
    }

    render() {

        let props = this.props;
        let broadCastNumOfSubscribers = this.state.broadCastNumOfSubscribers;
        //console.log('render', broadCastNumOfSubscribers);
        return (
            <div className="col-md-6 feed-col">
                <div className="section m-lg-b">
                    <div>
                        <p>
                            Preview
                        </p>
                    </div>
                    <ReactTooltip/>


                    <div className="posts-arrow posts-arrow-left" id="posts-arrow-left" onClick={this.scrollFun}>
                        <span className="fas fa-chevron-left" id="posts-arrow-left"></span>
                    </div>
                    <div className="posts-arrow posts-arrow-right" id="posts-arrow-right" style={{right: "0"}}
                         onClick={this.scrollFun}>
                        <span className="fas fa-chevron-right" id="posts-arrow-right"></span>
                    </div>
                    <div className="preview-screen multiple-posts-preview">
                        {
                            this.props.messageContent !== '' ?
                                <div className="preview-msg">
                                    {this.props.messageContent}
                                </div> :
                                ''
                        }
                        <div className="multiple-posts" style={{width: "768px"}}>

                            {props.multiple_custom.map((post, index) =>
                                <div key={post.id} className="preview-post">

                                    {props.loading_title_multiple_custom[index].loading_title ?
                                        <div className="loader" style={{
                                            margin: "10px 0 10px 25%",
                                            height: "100px",
                                            width: "100px"
                                        }}></div>
                                        :
                                        <div className="preview-post-picture post-picture-style"
                                             style={{backgroundImage: "url(" + post.imageFromLink + ")"}}>
                                        </div>
                                    }
                                    <div className="preview-post-title"
                                         style={{maxHeight: "50px", overflow: "hidden"}}>
                                        {post.title}
                                    </div>
                                    <div className="preview-post-button text-center">
                                        Get a Summery
                                    </div>
                                    <div className="preview-post-button text-center">
                                        Open in Browser
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/*<div className="section m-lg-b">*/}
                {/*<p><span className="fas fa-info-circle" data-tip="Your post reach"*/}
                {/*data-placement="top"></span>*/}
                {/*Post reach information*/}
                {/*</p>*/}
                {/*<div className="separator m-xl-b"></div>*/}

                {/*<div className="section-content text-center post-reach">*/}
                {/*{broadCastNumOfSubscribers > 0 ?*/}
                {/*<div className="section-content text-center post-reach">*/}
                {/*<p className="text-center text-bold m-m-b">Posts successfully broadcasted to:</p>*/}
                {/*<p className="letter text-bold"><span*/}
                {/*className="fas fa-paper-plane"></span><br/>{broadCastNumOfSubscribers} <br/>*/}
                {/*Subscribers*/}
                {/*</p>*/}
                {/*</div>*/}
                {/*:*/}
                {/*props.loaded === 1 ? <div className="loader" style={{margin: "10px 0 10px 25%"}}></div>*/}
                {/*:*/}
                {/*""*/}
                {/*}*/}
                {/*</div>*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default FacebookMultiplePostPreview